import {
    Component,
    Output,
    EventEmitter,
    OnInit
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
    FormGroup,
    FormControl,
    Validators
} from '@angular/forms';
import { AuthService } from '../../core/upgraded-providers';

@Component({
    selector: 'app-power-creep-types',
    templateUrl: './creep-types.component.pug',
    styleUrls: ['./creep-types.component.less']
})
export class CreepTypesComponent implements OnInit {
    @Output() creep: EventEmitter<IPowerCreep> = new EventEmitter<IPowerCreep>();

    public badge = this._authService.Me.badge;
    public form: FormGroup;

    public get creeps(): IPowerCreep[] {
        return this._route.snapshot.parent.data['creeps'];
    }

    constructor(
        private _route: ActivatedRoute,
        private _authService: AuthService
    ) {
        const name = new FormControl('', [Validators.required, Validators.maxLength(50)]);
        this.form = new FormGroup({ name });
    }

    ngOnInit() {
    }

    onSubmit(className: string) {
        this.creep.emit({
            name: this.form.controls.name.value,
            className,
            powers: {},
            level: 0
        });
    }

}
